<template>
  <div>
    <div class="row" v-if="canAccess">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-12">
              <div class="card-header">
                <div class="row">
                  <div class="col-md-4">
                    <div><label>ชื่อ Agent</label></div>
                    <a-input
                      v-model:value="user"
                      placeholder="ชื่อ Agent"
                      v-on:keyup.enter="searchUsers()"
                      allow-clear
                    />
                  </div>
                  <div class="col-md-4">
                    <div><label>Tier</label></div>
                    <a-select
                      mode="multiple"
                      style="width: 100%"
                      v-model:value="selects.tier"
                      placeholder="เลือก Tier"
                      v-if="selects.tiersLoaded"
                      :options="selects.tiers"
                    />
                  </div>
                  <div class="col-md-2">
                    <div><label style="color: transparent">ค้นหา</label></div>
                    <a-button type="primary" @click="searchUsers()">
                      ค้นหา
                    </a-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card-body"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="canAccess">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-8">
              <div class="card-header">
                <h4 class="card-title">รายการ Agent</h4>
              </div>
            </div>
            <div class="col-4">
              <div class="card-header text-right">
                <a-button
                  class="card-title"
                  type="primary"
                  title="ผูกสิทธิ์ Agent ให้กับผู้ใช้ที่มีอยู่ในระบบแล้ว"
                  @click="showAgentModel()"
                >
                  เพิ่ม Agent
                </a-button>
                <a-divider type="vertical" />
                <a-button
                  class="card-title"
                  shape="round"
                  title="ผูกสิทธิ์ Agent ให้กับผู้ใช้ที่มีอยู่ในระบบแล้ว"
                  @click="showModal()"
                >
                  Map Agent
                </a-button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <a-table
                      :columns="columns"
                      :data-source="data"
                      :loading="dataLoaded"
                      :scroll="{ x: 1000 }"
                    >
                      <template #status="{ record }">
                        <a-tag
                          :color="record.isActived ? 'success' : 'error'"
                          >{{
                            record.isActived ? "ใช้งาน" : "ไม่ใช้งาน"
                          }}</a-tag
                        >
                      </template>
                      <template #action="{ record }">
                        <a href="#" @click="showAgentModel(record.uid)"
                          >แก้ไข</a
                        >
                        <a-divider type="vertical" />
                        <a href="#" @click="showModal(record.uid)">Map Tier</a>
                      </template>
                    </a-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="canAccess">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-8">
              <div class="card-header">
                <h4 class="card-title">รายการ Agent Tiers</h4>
              </div>
            </div>
            <div class="col-4">
              <div class="card-header text-right">
                <a-button
                  class="card-title"
                  type="primary"
                  @click="showTierModel(0)"
                >
                  เพิ่ม Agent Tier
                </a-button>
                <a-divider type="vertical" />
                <a-button
                  class="card-title"
                  shape="round"
                  title="ดึงข้อมูลใหม่"
                  @click="getAgentTier"
                  :loading="dataTierLoaded"
                >
                  <template #icon><ReloadOutlined /></template>
                </a-button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <a-table
                      :columns="columns_tier"
                      :data-source="data_tier"
                      :loading="dataTierLoaded"
                      :scroll="{ x: 1000 }"
                    >
                      <template #status="{ record }">
                        <a-tag
                          :color="record.isActived ? 'success' : 'error'"
                          >{{
                            record.isActived ? "ใช้งาน" : "ไม่ใช้งาน"
                          }}</a-tag
                        >
                      </template>
                      <template #action="{ record }">
                        <a href="#" @click="showTierModel(record.id)">แก้ไข</a>
                      </template>
                    </a-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="canAccess === false">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <a-result
              status="403"
              title="403"
              sub-title="ขออภัย คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้"
            >
              <template #extra>
                <a-button type="primary" @click="goToHome"
                  >กลับหน้าหลัก</a-button
                >
              </template>
            </a-result>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      destroyOnClose="true"
      v-model:visible="visible"
      title="เพิ่ม/แก้ไข Agent จากผู้ใช้ที่มีอยู่"
      @ok="handleOk"
      :confirm-loading="confirmLoading"
    >
      <div class="row">
        <div class="col-12">
          <label>ชื่อ Agent</label>
          <a-select
            show-search
            placeholder="ค้นหา user"
            label-in-value
            v-model:value="model.user"
            style="width: 100%"
            :filter-option="false"
            :not-found-content="fetching ? undefined : null"
            @search="fetchUser"
            :options="selects.users"
            :disabled="model.edit"
          >
            <template v-if="fetching" #notFoundContent>
              <a-spin size="small" />
            </template>
          </a-select>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-12">
          <div><label>Tier</label></div>
          <a-select
            style="width: 100%"
            v-model:value="model.tier"
            placeholder="เลือก Tier"
            v-if="selects.tiersLoaded"
            :options="selects.tiers"
          />
        </div>
      </div>
      <br />
      <div class="form-group">
        <div><label>สถานะ</label></div>
        <a-switch
          checked-children="ใช้งาน"
          un-checked-children="ไม่ใช้งาน"
          v-model:checked="model.isActived"
        />
      </div>
    </a-modal>
    <a-modal
      destroyOnClose="true"
      v-model:visible="visible_agent"
      title="เพิ่ม/แก้ไข Agent"
      @ok="handleAgentOk"
      :confirm-loading="confirmAgentLoading"
    >
      <Form
        method="#"
        action="#"
        v-on:submit="onSaveAgent"
        :validation-schema="schema_agent"
        ref="myAgentForm"
      >
        <vee-input
          label="ชื่อ Agent"
          name="name"
          type="text"
          :value="agentModel.name"
          placeholder="Enter Agent Tier Name"
        />
        <vee-input
          label="Username (email)"
          name="email"
          :disabled="agentModel.uid"
          type="text"
          :value="agentModel.email"
          placeholder="Enter Username (Email)"
        />
        <vee-input
          label="ชื่อ"
          name="firstname"
          type="text"
          :value="agentModel.firstName"
          placeholder="Enter First Name"
        />
        <vee-input
          label="นามสกุล"
          name="lastname"
          type="text"
          :value="agentModel.lastName"
          placeholder="Enter Lastname"
        />
        <vee-input
          label="เบอร์โทรติดต่อ"
          name="tel"
          type="text"
          :value="agentModel.tel"
          placeholder="Enter Telephone No"
        />
        <div><label>ธนาคาร</label></div>
        <a-select
          showSearch
          style="width: 100%; margin-bottom: 10px"
          v-model:value="agentModel.bank"
          placeholder="เลือกธนาคาร"
          :options="selects.banks"
        />
        <label> เลขที่บัญชี &nbsp; </label>
        <a-tooltip
          title="เลขบัญชีที่ใช้ในการทำธุรกรรม"
          placement="top"
          arrow-point-at-center
        >
          <QuestionCircleTwoTone
            twoToneColor="#108ee9"
            style="display: inline-grid"
          />
        </a-tooltip>
        <vee-input
          name="bankaccount"
          type="text"
          :value="agentModel.bankAccount"
          placeholder="Enter Bank account"
        />
        <vee-input
          label="ตั้งรหัสผ่าน"
          name="password"
          type="password"
          v-if="!agentModel.uid"
          :value="agentModel.password"
          placeholder="Enter Password"
        />
        <vee-input
          label="ตั้งรหัสผ่าน"
          name="comfirmpassword"
          type="password"
          v-if="!agentModel.uid"
          :value="agentModel.comfirmpassword"
          placeholder="Enter Confirm Password"
        />
        <br />
        <div class="form-group">
          <checkbox v-model="agentModel.isActived" name="isactive"
            >เปิดใช้งาน</checkbox
          >
        </div>
        <button ref="submit_agent" style="display: none">Submit</button>
      </Form>
    </a-modal>
    <a-modal
      destroyOnClose="true"
      v-model:visible="visible_tier"
      title="เพิ่ม/แก้ไข Agent Tier"
      @ok="handleTierOk"
      :confirm-loading="confirmTierLoading"
    >
      <Form
        method="#"
        action="#"
        v-on:submit="onSaveTier"
        :validation-schema="schema_tier"
        ref="myTierForm"
      >
        <vee-input
          label="ชื่อ Agent Tier"
          name="name"
          type="text"
          :value="tierModel.name"
          placeholder="Enter Agent Tier Name"
        />
        <vee-input
          label="คำอธิบาย"
          name="description"
          type="text"
          :value="tierModel.description"
          placeholder="Enter Agent Tier Description"
        />
        <vee-input
          label="จำนวนเงินสูงสุดใน Wallet (บาท)"
          name="maxamount"
          type="number"
          :value="tierModel.maxamount"
          placeholder="Enter Max Amount"
        />
        <vee-input
          label="การเติมเงิน Wallet ขั้นต่ำ (บาท)"
          name="mintopup"
          type="number"
          :value="tierModel.mintopup"
          placeholder="Enter Min Topup"
        />
        <vee-input
          label="ยอดรวมสั่งซื้อต่อ Order (บาท)"
          name="maxamountperorder"
          type="number"
          :value="tierModel.maxamountperorder"
          placeholder="Enter max amount per oder"
        />
        <vee-input
          label="จำนวนสินค้าต่อ Order (ชิ้น)"
          name="maxitemperorder"
          type="number"
          :value="tierModel.maxitemperorder"
          placeholder="Enter max item per oder"
        />
        <button ref="submit" style="display: none">Submit</button>
      </Form>
    </a-modal>
  </div>
</template>

<script>
import { message } from "ant-design-vue";
import * as configuration from "../../../middleware/configuration";
import * as userservice from "../../../services/user";
import { ReloadOutlined, QuestionCircleTwoTone } from "@ant-design/icons-vue";
import { Form } from "vee-validate";
import { VeeInput, Checkbox } from "@/components";
import * as Yup from "yup";
import firebase from "firebase";
import banks from "../../../datas/banks.json";

const columns = [
  {
    title: "ชื่อ Agent",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "ชื่อ",
    dataIndex: "firstName",
    key: "firstName",
  },
  {
    title: "นามสกุล",
    dataIndex: "lastName",
    key: "lastName",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Tier",
    dataIndex: "tier",
    key: "tier",
    align: "right",
  },
  {
    title: "ธนาคาร",
    dataIndex: "bank",
    key: "bank",
    align: "center",
  },
  {
    title: "เลขบัญชี",
    dataIndex: "bankAccount",
    key: "bankAccount",
    align: "center",
  },
  {
    title: "สถานะ",
    slots: { customRender: "status" },
    key: "isActived",
    align: "center",
  },
  {
    title: "Action",
    key: "id",
    align: "center",
    slots: { customRender: "action" },
    width: 150,
  },
];
const columns_tier = [
  {
    title: "ชื่อ Agent Tier",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "คำอธิบาย",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "จำนวน Agent",
    dataIndex: "agentCount",
    key: "agentCount",
    align: "right",
  },
  {
    title: "สถานะ",
    slots: { customRender: "status" },
    key: "isActived",
    align: "center",
  },
  {
    title: "Action",
    key: "id",
    align: "center",
    slots: { customRender: "action" },
    width: 100,
  },
];
const key = "updatable";
export default {
  components: {
    VeeInput,
    Checkbox,
    Form,
    ReloadOutlined,
    QuestionCircleTwoTone,
  },
  methods: {
    async getAgentTier() {
      try {
        this.dataTierLoaded = true;
        let res = await userservice.getAgentTier();
        this.selects.tiers = res.data
          .filter((x) => x.isActived)
          .map((x) => {
            return {
              value: x.id,
              label: x.name,
            };
          });
        this.data_tier = res.data;
        this.selects.tiersLoaded = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.dataTierLoaded = false;
      }
    },
    async searchUsers() {
      this.dataLoaded = true;
      let req = {
        name: this.user,
        tiers: this.selects.tier,
      };
      try {
        let res = await userservice.searchAgentUsers(req);
        this.data = res.data;
        this.dataLoaded = false;
      } catch (error) {
        console.log(error);
        message.error("ดึงข้อมูล agent ไม่สำเร็จ");
      }
    },
    getBanks() {
      let bank_list = Object.keys(banks);
      bank_list.map((x) => {
        this.selects.banks.push({ value: x, label: banks[x].nice_name });
      });
    },
    async fetchUser(value) {
      if (value.length === 0) {
        this.selects.users = [];
        return;
      }

      try {
        let res = await userservice.searchUserWithoutAgent(value);
        this.selects.users = res.data.map((x) => {
          return { value: x.uid, label: `${x.name} ${x.surname} (${x.email})` };
        });
      } catch (error) {
        message.error("เกิดข้อผิดพลาดในการค้นหา");
      } finally {
        this.fetching = false;
      }
    },
    showModal(uid) {
      let data = this.data.find((x) => x.uid === uid);
      this.model = {
        edit: uid ? true : false,
        user: uid
          ? { value: uid, label: `${data.name} (${data.email})` }
          : null,
        tier: data ? data.tier : "",
        isActived: data ? data.isActived : true,
      };
      this.visible = true;
    },
    showAgentModel(id) {
      let data = this.data.find((x) => x.uid === id);
      this.agentModel = {
        uid: id,
        name: data ? data.name : "",
        firstName: data ? data.firstName : "",
        lastName: data ? data.lastName : "",
        email: data ? data.email : "",
        tel: data ? data.tel : "",
        bank: data ? data.bank : null,
        bankAccount: data ? data.bankAccount : "",
        isActived: data ? data.isActived : true,
      };

      this.visible_agent = true;
    },
    showTierModel(id) {
      let data = this.data_tier.find((x) => x.id === id);

      this.tierModel = {
        id: id,
        name: data ? data.name : "",
        description: data ? data.description : "",
        maxamount: data ? data.maxAmount : 0,
        mintopup: data ? data.minTopup : 0,
        maxamountperorder: data ? data.maxAmountPerOrder : 0,
        maxitemperorder: data ? data.maxItemPerOrder : 0,
      };
      this.visible_tier = true;
    },
    async handleOk() {
      let user = this.model.user;
      let tier = this.model.tier;

      if (!user) {
        message.error("กรุณาเลือก Agent");
        return;
      }
      if (!tier) {
        message.error("กรุณาเลือก Tier");
        return;
      }
      this.confirmLoading = true;
      let req = {
        uid: user.value,
        tier: tier,
        isActived: this.model.isActived,
        updatedBy: this.uid,
      };

      try {
        let res = await userservice.saveAgent(req);
        if (res.data) {
          message.success("บันทึกสำเร็จ");
          this.visible = false;
        }
      } catch (error) {
        message.error("บันทึกไม่สำเร็จ");
      } finally {
        await this.searchUsers();
        await this.getAgentTier();
        this.confirmLoading = false;
      }
    },
    handleAgentOk() {
      this.$refs.submit_agent.click();
    },
    handleTierOk() {
      this.$refs.submit.click();
    },
    async onSaveTier(values) {
      let data = {
        id: this.tierModel.id,
        name: values.name,
        description: values.description,
        maxamount: values.maxamount,
        mintopup: values.mintopup,
        maxamountperorder: values.maxamountperorder,
        maxitemperorder: values.maxitemperorder,
        isActived: true,
        uid: this.uid,
      };

      try {
        let res = await userservice.saveAgentTier(data);
        if (res.data) {
          message.success("บันทึกข้อมูลสำเร็จ");
          this.visible_tier = false;
        }
      } catch (error) {
        message.error("บันทึกข้อมูลไม่สำเร็จ");
      } finally {
        await this.getAgentTier();
      }
    },
    async onSaveAgent(values) {
      if (this.agentModel.bank === "" || this.agentModel.bank === undefined) {
        message.warning("กรุณาเลือกธนาคาร");
        return;
      }

      this.confirmAgentLoading = true;

      if (this.agentModel.uid) {
        let data = {
          uid: this.agentModel.uid,
          name: values.name,
          firstName: values.firstname,
          lastName: values.lastname,
          email: values.email,
          tel: values.tel?.startsWith("+66")
            ? values.tel
            : values.tel?.startsWith("0")
            ? values.tel?.replace("0", "+66")
            : "",
          bank: this.agentModel.bank,
          bankAccount: values.bankaccount,
          // password: values.password,
          isActived: this.agentModel.isActived,
        };

        var updateAgentUser = firebase
          .app()
          .functions()
          .httpsCallable("updateAgentUser");

        updateAgentUser(data)
          .then((res) => {
            message.success({
              content: "บันทึกขอมูลสำเร็จ!",
              key,
              duration: 2,
            });
            this.visible_agent = false;
          })
          .catch((err) => {
            message.error({
              content: "บันทึกขอมูลไม่สำเร็จ!",
              key,
              duration: 2,
            });
          })
          .finally(async () => {
            this.confirmAgentLoading = false;
            await this.searchUsers();
            await this.getAgentTier();
          });
      } else {
        let data = {
          name: values.name,
          firstName: values.firstname,
          lastName: values.lastname,
          email: values.email,
          tel: values.tel?.startsWith("+66")
            ? values.tel
            : values.tel?.startsWith("0")
            ? values.tel?.replace("0", "+66")
            : "",
          bank: this.agentModel.bank,
          bankAccount: values.bankaccount,
          password: values.password,
          isActived: this.agentModel.isActived,
        };
        var createAgentUser = firebase
          .app()
          .functions()
          .httpsCallable("createAgentUser");

        createAgentUser(data)
          .then((res) => {
            message.success({
              content: "บันทึกขอมูลสำเร็จ!",
              key,
              duration: 2,
            });
            this.visible_agent = false;
          })
          .catch((err) => {
            message.error({
              content: "บันทึกขอมูลไม่สำเร็จ!",
              key,
              duration: 2,
            });
          })
          .finally(async () => {
            this.confirmAgentLoading = false;
            await this.searchUsers();
            await this.getAgentTier();
          });
      }
    },
  },
  data() {
    return {
      uid: "",
      role: "",
      columns: columns,
      columns_tier: columns_tier,
      data: [],
      data_tier: [],
      dataLoaded: false,
      dataTierLoaded: false,
      canAccess: null,
      user: null,
      visible: false,
      visible_agent: false,
      visible_tier: false,
      confirmLoading: false,
      confirmAgentLoading: false,
      confirmTierLoading: false,
      agentModel: {
        name: "",
        email: "",
        firstname: "",
        lastname: "",
        tel: "",
        bank: null,
        bankaccount: "",
        isactived: true,
      },
      tierModel: {
        id: 0,
        name: "",
        description: "",
        maxamount: 0,
        mintopup: 0,
        maxamountperorder: 0,
        maxitemperorder: 0,
      },
      model: {
        user: "",
        tier: null,
        isActived: true,
      },
      selects: {
        tiers: [],
        tier: [],
        tiersLoaded: false,
        users: [],
        banks: [],
      },
    };
  },
  async beforeMount() {
    this.uid = await configuration.getUid();
    let user = await configuration.getIdTokenResult();
    if (user) {
      this.role = user.claims.role;
      if (this.role === "manager" || this.role === "admin") {
        this.canAccess = true;
        await this.searchUsers();
        await this.getAgentTier();
      } else {
        this.canAccess = false;
      }
    }
    this.getBanks();
  },
  setup() {
    const schema_tier = Yup.object().shape({
      name: Yup.string().required().label("The name"),
      description: Yup.string().nullable().label("The description"),
      maxamount: Yup.number()
        .required()
        .min(0)
        .label("The max amount")
        .transform((_, val) => {
          return val === "" || isNaN(val) ? -1 : val * 1;
        }),
      mintopup: Yup.number()
        .required()
        .min(0)
        .label("The min topup")
        .transform((_, val) => {
          return val === "" || isNaN(val) ? -1 : val * 1;
        }),
      maxamountperorder: Yup.number()
        .required()
        .min(0)
        .label("The max amount per order")
        .transform((_, val) => {
          return val === "" || isNaN(val) ? -1 : val * 1;
        }),
      maxitemperorder: Yup.number()
        .required()
        .min(0)
        .label("The max item per order")
        .transform((_, val) => {
          return val === "" || isNaN(val) ? -1 : val * 1;
        }),
    });

    const phoneRegExp =
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
    const schema_agent = Yup.object().shape({
      name: Yup.string().required().label("The name"),
      email: Yup.string().email().required().label("The email"),
      firstname: Yup.string().required().label("The first name"),
      lastname: Yup.string().required().label("The last name"),
      tel: Yup.string()
      .max(10)
        .matches(phoneRegExp, "Phone number is not valid")
        .required()
        .label("The Phone number"),
      bankaccount: Yup.string().required().label("The bank account"),
      password: Yup.string().min(8).required().label("The password"),
      comfirmpassword: Yup.string()
        .required()
        .label("The confirm password")
        .oneOf([Yup.ref("password")], "Passwords do not match"),
    });

    return {
      schema_tier,
      schema_agent,
    };
  },
};
</script>

<style lang="scss" scoped>
.ant-btn > span {
  display: block !important;
}
</style>